// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"99809f05","213":"6e13a8cc","314":"b3a92f63","317":"5223de9b","382":"996aa664","453":"d8ae0084","480":"e0049733","588":"ec4e199d","667":"5366a866","738":"2cceb581","804":"c59fbe45","822":"2d278e7a","919":"91fa61ac","955":"3d487694","994":"6639906e"}[chunkId] + ".chunk.js";
};